import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'

// GET SECCIONES
export const getVacantesConFirmas = async () => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/getVacantesConFirmas', 'GET');
  return response
}

export const FirmarVacante = (data) => {
  const respuesta = PrivateInterceptor("Payrolls/Vacantes/FirmarVacante", "POST", {Detalle: data});
  return respuesta;
};

export const GuardarVacante = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Vacantes/GuardarVacante", "POST", {Datos});
  return respuesta
};

export const EditarVacante = (Datos) => {
  const respuesta = PrivateInterceptor("Payrolls/Vacantes/EditarVacante", "POST", {Datos});
  return respuesta
};

export const chageEstadoVacantes = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Vacantes/chageEstadoVacantes`, 'POST', data);
  return result;
}

export const chageEstadoVacantesDetalles = async (data) => {
  const result = await PrivateInterceptor(`Payrolls/Vacantes/chageEstadoVacantesDetalles`, 'POST', data);
  return result;
}

export const getDetallesVacantes = async () => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/getDetallesVacantes', 'GET');
  return response
}

export const getDetallesVacantesPorId = async (IdVacante) => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/getDetallesVacantesPorId', 'POST', {IdVacante});
  return response
}

export const GuardarDetallesVacantes = async (Datos) => {
  const result = await  PrivateInterceptor(`Payrolls/Vacantes/GuardarDetallesVacantes`, 'POST', {Datos});
  return result;
}

export const EliminarVacanteDetalles = async (IdVacantesDetalle) => {
  const result = await  PrivateInterceptor(`Payrolls/Vacantes/EliminarVacanteDetalles`, 'POST', {IdVacantesDetalle});
  return result;
}

export const changeCheckList = async (IdVacanteDetalle, field, value) => {
  const result = await  PrivateInterceptor(`Payrolls/Vacantes/changeCheckList`, 'POST', {IdVacanteDetalle, field, value});
  return result;
}

export const changeEntrevista = async (IdVacanteDetalle, value) => {
  const result = await  PrivateInterceptor(`Payrolls/Vacantes/changeEntrevista`, 'POST', {IdVacanteDetalle, value});
  return result;
}

export const getUsersPorId = async (IdUsersEntrevista) => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/getUsersPorId', 'POST', {IdUsersEntrevista});
  return response;
}

export const getCheckList = async () => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/getCheckList', 'GET');
  return response
}

export const GuardarEntrevistas = async (Datos) => {
  const result = await  PrivateInterceptor(`Payrolls/Vacantes/GuardarEntrevistas`, 'POST', {Datos});
  return result;
}

export const obtenerEntrevistasPorIdVacante = async (IdVacanteDetalle) => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/obtenerEntrevistasPorIdVacante', 'POST', {IdVacanteDetalle});
  return response
}

export const eliminarEntrevista = async (IdEntrevista) => {
  const response = await PrivateInterceptor('Payrolls/Vacantes/eliminarEntrevista', 'POST', {IdEntrevista});
  return response
}